function defineNamespace(implementation) {
  return { ...implementation, [Symbol.onexus.namespace]: true };
}
function defineFunction(handler) {
  return handler;
}
function defineEvent(...listeners) {
  return { [Symbol.onexus.event]: listeners };
}
const createEventTopic = defineEvent;
export {
  createEventTopic,
  defineEvent,
  defineFunction,
  defineNamespace
};
